import { Route, Routes } from "react-router-dom";
import LoginPage from '../admin/pages/LoginPage/LoginPage'
import Dashboard from "../admin/pages/Dashboard";
import AdminLayout from "../layouts/AdminLayout";
import TourPlaces from "../admin/pages/TourPlaces/TourPlaces";
import PlacesVisited from "../admin/pages/PlacesVisited/PlacesVisited";
import LandingPage from "../admin/pages/LandingPage/LandingPage";
import ViewTourDetails from "../admin/pages/TourDetails/ViewTourDetails";
import ExploreImages from "../admin/pages/TourDetails/ExploreImages";
import TourGalleryImages from "../admin/pages/TourDetails/TourGalleryImages";
import RouteMaps from "../admin/pages/TourDetails/RouteMaps";
import CompleteYourDay from "../admin/pages/TourDetails/CompleteYourDay";
import FrequentlyBookedTogether from "../admin/pages/TourDetails/FrequentlyBookedTogether";
import ExploreMoreDestinations from "../admin/pages/TourDetails/ExploreMoreDestinations";

function AdminRoutes() {
    return (
        <Routes>
            {/* Login page without sidebar */}
            <Route path="/admin/login" element={<LoginPage />} />

            <Route
                path="/admin/dashboard"
                element={
                    <AdminLayout>
                        <Dashboard />
                    </AdminLayout>
                } />

            <Route
                path="/admin/tour-places"
                element={
                    <AdminLayout>
                        <TourPlaces />
                    </AdminLayout>
                } />
            <Route
                path="/admin/view-places"
                element={
                    <AdminLayout>
                        <PlacesVisited />
                    </AdminLayout>
                }
            />

            <Route
                path="/admin/landing-page"
                element={
                    <AdminLayout>
                        <LandingPage />
                    </AdminLayout>
                }
            />

            <Route
                path="/admin/view-tour-details"
                element={
                    <AdminLayout>
                        <ViewTourDetails />
                    </AdminLayout>
                }
            />

            <Route
                path="/admin/add-explore-images"
                element={
                    <AdminLayout>
                        <ExploreImages />
                    </AdminLayout>
                }
            />

            <Route
                path="/admin/tour-gallery"
                element={
                    <AdminLayout>
                        <TourGalleryImages />
                    </AdminLayout>
                }
            />

            <Route
                path="/admin/route-maps"
                element={
                    <AdminLayout>
                        <RouteMaps />
                    </AdminLayout>
                }
            />

            <Route
                path="/admin/complete-your-day"
                element={
                    <AdminLayout>
                        <CompleteYourDay />
                    </AdminLayout>
                }
            />
            <Route path="/admin/frequently-booked-together" element={<AdminLayout><FrequentlyBookedTogether /></AdminLayout>} />
            <Route path="/admin/explore-more-destinations" element={<AdminLayout><ExploreMoreDestinations /></AdminLayout>} />


        </Routes>
    )
}

export default AdminRoutes
